import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  hasShown: null, // Whether the modal has been shown
  lastShownTime: "", // The last time it was shown
  isBetaTimeoutPopupOpen: false, // Controls whether the modal is currently open
};

const betaTimeoutPopupSlice = createSlice({
  name: "betaTimeoutPopup",
  initialState,
  reducers: {
    checkAndShowBetaTimeoutPopup: (state) => {
      const currentTime = new Date().getTime();
      const lastShownTime = state.lastShownTime
        ? new Date(state.lastShownTime).getTime()
        : 0;

      // If modal hasn't been shown or 2 minutes (120000ms) have passed, show it
      if (!state.hasShown || currentTime - lastShownTime > 300000) {
        state.isBetaTimeoutPopupOpen = true;
        state.lastShownTime = new Date().toISOString();
        state.hasShown = true;
      }
      // if (
      //   !state.hasShown ||
      //   currentTime - lastShownTime > 10 * 60 * 60 * 1000
      // ) {
      //   state.isBetaTimeoutPopupOpen = true;
      //   state.lastShownTime = new Date().toISOString();
      //   state.hasShown = true;
      // }
    },
    closeBetaTimeoutPopup: (state) => {
      state.isBetaTimeoutPopupOpen = false;
    },
    resetBetaTimeoutPopup: (state) => {
      state.hasShown = null;
      state.lastShownTime = "";
      state.isBetaTimeoutPopupOpen = false;
    },
  },
});

export const {
  checkAndShowBetaTimeoutPopup,
  closeBetaTimeoutPopup,
  resetBetaTimeoutPopup,
} = betaTimeoutPopupSlice.actions;
export default betaTimeoutPopupSlice.reducer;
